import type * as React from 'react';
import { ServiceMarketplace } from '@/b2b/service-marketplace';
import { type NestedMenuItem, SidebarMain } from '@/dashboard/sidebar-main';
import { SidebarUser, type SidebarUserProps } from '@/dashboard/sidebar-user';
import {
  Sidebar,
  SidebarContent,
  SidebarFooter,
  SidebarHeader,
} from '@/ui/sidebar';

interface DashboardSidebarProps extends React.ComponentProps<typeof Sidebar> {
  logo?: React.ReactNode;
  currentServiceId?: string;
  orgId?: string;
  orgSwitcher?: React.ReactNode;
  menuItems: NestedMenuItem[];
  user: SidebarUserProps['user'];
  links?: SidebarUserProps['links'];
  logoutLabel?: SidebarUserProps['logoutLabel'];
  onLogout?: () => void;
  onNavigate?: (path: string) => void;
}

export function DashboardSidebar({
  logo,
  currentServiceId,
  orgId,
  orgSwitcher,
  menuItems,
  user,
  links,
  logoutLabel,
  onLogout,
  onNavigate,
  ...props
}: DashboardSidebarProps) {
  return (
    <Sidebar collapsible="icon" {...props}>
      <SidebarHeader>
        <div className="flex items-center gap-2 px-1.5 py-1.5 group-data-[collapsible=icon]:flex-col group-data-[collapsible=icon]:gap-1 group-data-[collapsible=icon]:px-0">
          <div className="min-w-0 flex-1 group-data-[collapsible=icon]:flex-none">
            {logo || <span className="font-semibold text-base">App</span>}
          </div>
          {currentServiceId && orgId ? (
            <ServiceMarketplace
              currentServiceId={currentServiceId}
              orgId={orgId}
            />
          ) : null}
        </div>
      </SidebarHeader>
      <div className="group-data-[collapsible=icon]:hidden">{orgSwitcher}</div>
      <SidebarContent>
        <SidebarMain items={menuItems} onNavigate={onNavigate} />
      </SidebarContent>
      <SidebarFooter>
        <SidebarUser
          user={user}
          links={links}
          logoutLabel={logoutLabel}
          onLogout={onLogout}
          onNavigate={onNavigate}
        />
      </SidebarFooter>
    </Sidebar>
  );
}
